/** 与 pipeline-kernel 同源，避免两套 SkuModuleMeta 漂移 */
export type { SkuModuleMeta } from '../pipeline-kernel/types';

/** 场景布局 / 下单资源配置编辑模式 */
export type ResourceEditMode = 'sku-create' | 'order-post-paid' | 'order-fixed' | 'order-custom';

export type SceneLayoutScene = 'sku-create' | 'order';

export const SKU_RESOURCE_MODULES_FIELD = 'skuResourceModules';

export type SkuResourceModulesState = Partial<Record<string, boolean>>;

/** innerForm 交付类型（与 L3 INNER_FORM_DEPLOY_TYPE_CODES 对齐，插件层用 string 避免反向依赖） */
export type SceneLayoutDeployTypeCode =
  | 'VirtualMachine'
  | 'ContainerInstance'
  | 'ModelSubscription'
  | 'ModelInstance'
  | 'TrainingCluster'
  | 'AppInstance'
  | 'ElasticBareMetal'
  | 'BareMetal';
